export default __webpack_public_path__ + "static/media/sort.1f7dbf7b.svg";